module.exports = {
  createCompany: '创建公司',
  createCatalog: '创建目录',
  edit: '编辑',
  activate: '启用',
  deactivate: '关闭',
  cancel: '取消',
  create: '创建',
  update: '更新',
  submit: '提交',
};



// WEBPACK FOOTER //
// ./src/lang/zh/actions.js